import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    background: '#F2F1F1',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rootForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    marginTop: '31vh',
    marginBottom: '3%',
    maxHeight: '57vh !important',
    overflowX: 'hidden',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
  },
  summary: {
    backgroundColor: '#C4C4C4',
    borderRadius: '5px',
  },
  details: {
    backgroundColor: '#ECECEC',
    width: '100%',
    padding: '16px !important',
    flexDirection: 'column',
  },
  medium: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '97%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  input: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
  },
  inputText: {
    textTransform: 'uppercase',
  },
  label: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '13px',
    fontWeight: 'bold',
    float: 'left',
    marginBottom: '7px',
    width: '97%',
  },
}));

export default useStyles;
